import React from 'react';
import PageSyle from '../style';
import NextBackNav from '../../../components/nextBackNav';
import RoundScreen from '../../../components/roundScreen';

export default function Page17({nextPressed, backPressed, nextSlideExzists, previousSlideExzists}) {
	let style = PageSyle();
	return (
		<div style={style.outerStyle()}>
			<RoundScreen
				title='Run 3 - 4 Rounds'
				isNumbered={true}
				rounds={[
					[
						{
							header: 'Type',
							value: 'Alpha',
						},
						{
							header: 'C.C.M.R’s',
							value: 'DUMBBELL WIDE - STANCE BOX SQUATS',
						},
						{
							header: 'REPS / Min',
							value: '10',
						},
						{
							header: 'WEIGHT LEVEL',
							value: 'Mild --> Heavy',
						},
					],
					[
						{
							header: 'Type',
							value: 'Beta',
						},
						{
							header: 'C.C.M.R’s',
							value: 'BOX JUMPS',
						},
						{
							header: 'REPS / Min',
							value: '5',
						},
						{
							header: 'WEIGHT LEVEL',
							value: 'Body Weight',
						},
					],
					[
						{
							header: 'Type',
							value: 'Beta',
						},
						{
							header: 'C.C.M.R’s',
							value: 'LATERAL LUNGES',
						},
						{
							header: 'REPS / Min',
							value: '6 (each side)',
						},
						{
							header: 'WEIGHT LEVEL',
							value: 'Body Weight',
						},
					],
					[
						{
							header: 'Type',
							value: 'Beta',
						},
						{
							header: 'C.C.M.R’s',
							value: 'SISSY SQUATS',
						},
						{
							header: 'REPS / Min',
							value: '10',
						},
						{
							header: 'WEIGHT LEVEL',
							value: 'Body Weight',
						},
					],
				]}
			/>
			<p style={style.takeABreakTextStyle()}>Take a 1 - 2 minute break</p>
			<NextBackNav
				message='Ready to continue?'
				mt={true}
				nextPressed={nextPressed}
				backPressed={backPressed}
				nextSlideExzists={nextSlideExzists}
				previousSlideExzists={previousSlideExzists}
			/>
		</div>
	);
}
